module.exports = __webpack_public_path__ + "img/21-image-2@2x.627c80fa.png";